import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRange2 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 160 160",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M77.0639 135.123C78.1363 136.396 79.3365 137.642 80.6699 138.853C93.3056 149.926 109.243 150.452 121.749 140.855C134.961 129.366 136.092 112.937 128.933 100.951C130.077 100.265 131.2 99.5021 132.295 98.6611C153.675 80.0711 143.42 48.5477 117.605 43.8397C115.757 43.6846 113.949 43.6585 112.188 43.7512C112.619 29.1962 102.473 15.208 85.9569 12.1959C67.8837 10.6796 53.6401 21.4943 49.7807 35.1334C21.1707 35.4987 4.09018 67.039 27.2637 88.0925C29.0106 89.6233 30.8206 90.9525 32.6759 92.0812C23.8359 103.264 23.269 119.644 37.1542 132.261C49.3994 142.991 64.7457 143.817 77.0639 135.123Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgRange2);
export default ForwardRef;
